module.exports = __webpack_public_path__ + "img/demo_woman3.9761e35b.svg";